import { isArray, isObject, mapKeys, mapValues, snakeCase } from 'lodash'

export const toSnakeCase = (object: Object): Object => {
  if (isArray(object)) {
    return object.map(toSnakeCase)
  } else if (isObject(object)) {
    return mapKeys(mapValues(object, toSnakeCase), (_value, key) => snakeCase(key))
  } else {
    return object
  }
}
